import * as React from "react";
import { Box, Stack, Tabs, Tab } from "@mui/material";
import ScheduleEditor from "./components/ScheduleEditor";
import EventViewer from "./components/EventViewer";

import { useTranslation } from "react-i18next";




export default function AutomationPage(props) {

	const {facility, clientInfo} = props;

	const [activeTab, setActiveTab] = React.useState("schedule");

	const { t } = useTranslation();

	return (
		<Stack>
			<Box sx={{borderBottom: 1, marginBottom: 0, borderColor: "divider"}}>
				<Tabs value={activeTab} onChange={(event, newValue) => setActiveTab(newValue)}>
					<Tab
						label={t("Schedule")}
						value="schedule"
					/>
					<Tab
						label={t("Events")}
						value="events"
					/>
				</Tabs>
			</Box>
			{
				(activeTab === "schedule") &&
				<ScheduleEditor facility={facility}/>
			}
			{
				(activeTab === "events") &&
				<EventViewer localTimezone={clientInfo.timezone} facility={facility}/>
			}
		</Stack>
		
	);
}
